import { Nullable, UserRelation } from '@aibees/shared/definition';

export enum IntegrationStatus {
  All = 'Available,Connected,comingSoon',
  Available = 'Available',
  Connected = 'Connected',
  ComingSoon = 'Coming Soon',
}

export enum IntegrationCategory {
  LeadGeneration = 'LeadGeneration',
  CRM = 'CRM',
  Marketing = 'Marketing',
}

export enum IntegrationType {
  SMART_LEAD = 'SMART_LEAD',
  SALES_FORCE = 'SALES_FORCE',
  HUB_SPOT = 'HUB_SPOT',
}

export enum IntegrationDomain {
  SmartLeadAi = 'SmartLead.ai',
  SalesForceAi = 'Salesforce.ai',
  HubSpotAi = 'HubSpot.ai',
}

export type IntegrationCountResponse = {
  [key in IntegrationType]: {
    count: number;
    available: boolean;
  };
};

export interface IntegrationConfig {
  domain: IntegrationDomain;
  category: IntegrationCategory;
  description: string;
  icon: string;
  status: IntegrationStatus;
  name?: string;
  type: IntegrationType;
}

export interface IntegrationConnection {
  name?: string;
  type: IntegrationType;
  id: string;
  workspace: UserRelation;
  created: string;
  modified: string;
  default: boolean;
  config: {
    token: Nullable<string>;
  };
  primary: boolean;
  status: IntegrationStatus;
}
export interface IntegrationCampaign {
  id: number;
  name: string;
  created: string;
  modified: string;
}

export interface IntegrationTabProps {
  className?: string;
  value: IntegrationStatus;
  key?: IntegrationStatus | string;
  label?: string;
  disabled?: boolean;
}

export interface IntegrationEditRequest {
  name?: string;
  config?: {
    token?: Nullable<string>;
  };
}

export interface IntegrationAddRequest {
  name?: string;
  config?: {
    token?: Nullable<string>;
  };
  type?: IntegrationType;
}
export interface CampaignAddRequest {
  name?: string;
  tokenId?: string;
}

export type IntegrationPanelProps = IntegrationTabProps;
